import React from 'react';
import { AiOutlineHome, AiOutlineStop } from "react-icons/ai";
import { VscSettings } from "react-icons/vsc";
import { Link } from "react-router-dom";
import './globalSettings.css';
import {ReactComponent as Message} from "../../images/message.svg"
import {ReactComponent as MessageGroup} from "../../images/message_group.svg"
import { MdFileDownload } from "react-icons/md";


const GlobalSettings: React.FC = () => {
    return (
        <div>
            <div className='breadcrumb-section'>
                <AiOutlineHome /> <span className="small"> &gt; <span className="text-muted">Settings</span> </span>
            </div>

            <div className='mt-3'>
                <h5>View Settings</h5>
                <p className="text-muted small">You can view / define settings for SecureProctor</p>
            </div>

            <div className='mt-4'>
                <div className='d-flex align-items-center mb-3'>
                    <p className='h5 text-quill-lighter mr-2 mb-0'>CI Configurations</p>
                    <hr className='flex-grow-1' />
                </div>

                <div className='d-flex'>
                    <Link to="/settings/viewCiConfig" className='text-body text-decoration-none border rounded-lg d-flex flex-column justify-content-center align-items-center shadow-sm settings-tile mr-3'>
                        <Message />
                        <p className='px-2 text-center mt-2 mb-0'>Manage Credibility Index Configuration</p>
                    </Link>
                </div>
            </div>
            

            <div className='mt-4'>
                <div>
                    <div className='d-flex align-items-center mb-3'>
                        <p className='h5 text-quill-lighter mr-2 mb-0'>MSB Settings</p>
                        <hr className='flex-grow-1' />
                    </div>

                    <div>
                        <Link to="/settings/msbSettings/prohibitedSoftwares" className='text-body text-decoration-none border rounded-lg d-flex flex-column justify-content-center align-items-center shadow-sm settings-tile'>
                            <AiOutlineStop size={48} />
                            <p className='px-2 text-center mt-2 mb-0'>Prohibited Softwares</p>
                        </Link>
                    </div>
                </div>

                <div className='mt-4'>
                    <div className='d-flex align-items-center mb-3'>
                        <p className='h5 text-quill-lighter mr-2 mb-0'>Miscellaneous</p>
                        <hr className='flex-grow-1' />
                    </div>

                    <div className='d-flex'>
                        <Link to="/settings/accountDetails" className='text-body text-decoration-none border rounded-lg d-flex flex-column justify-content-center align-items-center shadow-sm settings-tile mr-3'>
                            <VscSettings size={48} />
                            <p className='px-2 text-center mt-2 mb-0'>Other Settings</p>
                        </Link>
                        <Link to="/settings/downloadProctorFeedback" className='text-body text-decoration-none border rounded-lg d-flex flex-column justify-content-center align-items-center shadow-sm settings-tile'>
                            <MdFileDownload size={48} />
                            <p className='px-2 text-center mt-2 mb-0'>Download Proctor Feedback</p>
                        </Link>
                    </div>
                </div>

                <div className='mt-4'>
                    <div className='d-flex align-items-center mb-3'>
                        <p className='h5 text-quill-lighter mr-2 mb-0'>GDPR (Candidate)</p>
                        <hr className='flex-grow-1' />
                    </div>

                    <div className='d-flex'>
                        <Link to="/settings/gdprUtility/gdprRequest" className='text-body text-decoration-none border rounded-lg d-flex flex-column justify-content-center align-items-center shadow-sm settings-tile mr-3'>
                            <Message />
                            <p className='px-2 text-center mt-2 mb-0'>Process GDPR Request</p>
                        </Link>
                   
                        <Link to="/settings/gdprUtility/bulkGdprRequest" className='text-body text-decoration-none border rounded-lg d-flex flex-column justify-content-center align-items-center shadow-sm settings-tile'>
                            <MessageGroup />
                            <p className='px-2 text-center mt-2 mb-0'>Process GDPR Request in Bulk</p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GlobalSettings;